/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Partner_Security_Remove_Passkey_DescriptionInputs */



/**
* | output |
* | --- |
* | "\"{name}\" will no longer be able to sign in to the partner portal. This cannot be undone." |
*
* @param {Partner_Security_Remove_Passkey_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_remove_passkey_description = /** @type {((inputs: Partner_Security_Remove_Passkey_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Remove_Passkey_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mit „${i?.name}“ kann man sich nicht mehr im Partnerportal anmelden. Dies kann nicht rückgängig gemacht werden.`)
	return /** @type {LocalizedString} */ (`"${i?.name}" will no longer be able to sign in to the partner portal. This cannot be undone.`)
});